import { type ComputedDatum, type LineCustomSvgLayer } from '@nivo/line'
import { area } from 'd3-shape'
import { some } from 'lodash'
import { useTheme } from '@mui/material'
import { type LineChartSeries } from './types'

export const LineChartRangeLayer: LineCustomSvgLayer<LineChartSeries> = ({ series, yScale }) => {
    const theme = useTheme()

    return series.map((serie) => {
        const points = serie.data
        if (!some(points, (point) => point.data.range)) {
            return null
        }

        const areaGenerator = area<ComputedDatum<LineChartSeries>>()
            .x((d) => d.position.x)
            .y0((d) => (d.data.range ? yScale(d.data.range.min) : d.position.y))
            .y1((d) => (d.data.range ? yScale(d.data.range.max) : d.position.y))

        return <path key={serie.id} d={areaGenerator(points) || undefined} fillOpacity={0.25} fill={theme.palette.customtext.black20} />
    })
}
